import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import type { DashboardAgentState } from '../../gen/openapi';

export const dashboardMetadataKey = (conversationId: string) => ['dashboardAgentState', conversationId] as const;

export const useDashboardMetadataWriter = (conversationId: string): ((state: DashboardAgentState | null) => void) => {
  const queryClient = useQueryClient();
  return useCallback(
    (state: DashboardAgentState | null) => {
      queryClient.setQueryData(dashboardMetadataKey(conversationId), state);
    },
    [queryClient, conversationId],
  );
};
